export default __webpack_public_path__ + "static/media/cg_logo_dark.23c7ba53.png";